export default __webpack_public_path__ + "assets/da6a4de78697574dfb22899eff99739d.svg";